import { jsx as d } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { toChildArray as b, Fragment as v } from "../../../external/preact/dist/preact.module.js";
import c from "classnames";
/* empty css              */
import { TableBody as w } from "./components/TableBody.js";
import { InteractiveBody as C } from "./components/InteractiveBody.js";
import _ from "./components/SkeletonBody.js";
import { ErrorMessageDisplay as T } from "../ErrorMessageDisplay/ErrorMessageDisplay.js";
import { useMemo as n } from "../../../external/preact/hooks/dist/hooks.module.js";
import k from "../../../images/no-data-female.svg.js";
import { DataGridProvider as N } from "./utils/DataGridProvider.js";
import { useDataGridContext as x } from "./hooks/useDataGridContext.js";
import { TableHeaderCell as B } from "./components/TableHeaderCell.js";
const K = Object.freeze({
  activeIndex: -1,
  index: -1
});
function s({ errorDisplay: e, ...a }) {
  return /* @__PURE__ */ d("div", { style: { width: "100%" }, children: /* @__PURE__ */ d(N, { children: /* @__PURE__ */ d(R, { ...a, errorDisplay: e }) }) });
}
function R({ errorDisplay: e, ...a }) {
  var r, m;
  const i = n(() => b(a.children), [a.children]), g = n(() => i.find((t) => (t == null ? void 0 : t.type) === y), [i]), l = n(() => {
    var t;
    return ((t = a.data) == null ? void 0 : t.length) === 0;
  }, [a.data]), u = n(() => !a.loading && (l || a.error), [l, a.error, a.loading]), { getMinWidthByColumn: f } = x(), o = a.columns.filter((t) => t.visible !== !1).map((t) => ({ ...t, minWidth: f(t.key) })), h = o.map((t) => `minmax(${(t.minWidth || 100) + 40}px, ${t.flex || 1}fr)`).join(" ");
  return /* @__PURE__ */ d(
    "div",
    {
      className: c("adyen-pe-data-grid", {
        "adyen-pe-data-grid--condensed": a.condensed,
        "adyen-pe-data-grid--outline": a.outline,
        "adyen-pe-data-grid--scrollable": a.scrollable,
        "adyen-pe-data-grid--loading": a.loading,
        "adyen-pe-data-grid--empty": l || a.error
      }),
      style: `--adyen-pe-data-grid-cols: ${o.length}; --adyen-pe-data-grid-cells: ${h};`,
      children: /* @__PURE__ */ d(v, { children: [
        /* @__PURE__ */ d("div", { className: "adyen-pe-data-grid__table-wrapper", children: [
          /* @__PURE__ */ d("div", { role: "table", className: "adyen-pe-data-grid__table", children: [
            /* @__PURE__ */ d("div", { className: "adyen-pe-data-grid__head", role: "rowgroup", children: /* @__PURE__ */ d("div", { role: "rowheader", className: "adyen-pe-data-grid__header", style: a.loading ? { width: "100%" } : {}, children: o.map((t) => /* @__PURE__ */ d(B, { label: t.label, position: t.position, cellKey: t.key }, t.key)) }) }),
            /* @__PURE__ */ d(D, { ...a, columns: o, emptyBody: l })
          ] }),
          u && (l && !a.error ? /* @__PURE__ */ d(
            T,
            {
              title: ((r = a.emptyTableMessage) == null ? void 0 : r.title) ?? "thereAreNoResults",
              message: (m = a.emptyTableMessage) == null ? void 0 : m.message,
              imageDesktop: k,
              centered: !0
            }
          ) : a.error && e ? e() : null)
        ] }),
        g
      ] })
    }
  );
}
function D(e) {
  const a = n(() => e.loading || e.emptyBody || e.error, [e.emptyBody, e.error, e.loading]);
  return /* @__PURE__ */ d(
    "div",
    {
      role: "rowgroup",
      className: c("adyen-pe-data-grid__body"),
      style: a && { display: "grid", gridTemplateColumns: "1fr" },
      children: a ? /* @__PURE__ */ d(_, { columnsNumber: e.columns.length, loading: e.loading }) : e.onRowClick ? /* @__PURE__ */ d(
        C,
        {
          onRowHover: e.onRowHover,
          data: e.data,
          columns: e.columns,
          onRowClick: e.onRowClick,
          customCells: e.customCells
        }
      ) : /* @__PURE__ */ d(
        w,
        {
          onRowHover: e.onRowHover,
          data: e.data,
          customCells: e.customCells,
          columns: e.columns
        }
      )
    }
  );
}
s.Footer = y;
function y({ children: e }) {
  return /* @__PURE__ */ d("div", { className: "adyen-pe-data-grid__footer", children: e });
}
s.defaultProps = {
  condensed: !1,
  outline: !0,
  scrollable: !0
};
export {
  K as INITIAL_STATE,
  s as default
};
